import { asset1, asset2, asset3, asset4 } from './assets'

const assets = [
  { src: asset1, x: 0, y: 0, itemId: 'dieCast', position: 'Right' },
  // { src: asset2, x: 73.6235, y: 100.1614, overlay: true },
  { src: asset3, x: 785.8983, y: 0, itemId: 'dieCast', position: 'Left' },
  // { src: asset4, x: 865.2502, y: 100.1614, overlay: true },
]

const data = {
  assets: assets,
}

export default data
